import { useState, useEffect } from "react";

/**
 * useIsMobile - Returns true if viewport width is <= maxWidth
 */
export function useIsMobile(maxWidth = 600) {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= maxWidth);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= maxWidth);
    window.addEventListener("resize", handler);
    handler(); // Update state after possible resize right after mount
    return () => window.removeEventListener("resize", handler);
  }, [maxWidth]);

  return isMobile;
}
